import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-table-balance-badge',
  templateUrl: './table-balance-badge.component.html',
  styleUrls: ['./table-balance-badge.component.css']
})
export class TableBalanceBadgeComponent {
  @Input() value: number;
}
